<template>
  <div class="question-options">
    <!-- 多选填空题 -->
    <el-table
      :data="question.options"
      :show-header="false"
      stripe
      class="multitext-options">
      <el-table-column>
        <template slot-scope="scope">
          <span>{{scope.row.title}} </span>
          <el-tag v-if="scope.row.required"
                  type="info"
                  size="mini">必填
          </el-tag>
          <el-tag type="info"
                  size="mini">{{inputTypes[scope.row.inputType]}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-input
            v-model="texts[scope.$index]"
            placeholder="请输入内容"
            size="mini"
            :disabled="disabled"
            @change="(val) => changeText(scope.row.id, val)">
            <i slot="prefix"
               class="el-input__icon el-icon-edit"></i>
            <i v-show="isRight(scope.$index)"
               slot="suffix"
               class="el-input__icon el-icon-success"
               style="color:#67C23A;"></i>
            <i v-show="isError(scope.$index)"
               slot="suffix"
               class="el-input__icon el-icon-error"
               style="color:#F56C6C;"></i>
            <el-button slot="append"
                       icon="el-icon-refresh"
                       style="padding-left: 13px;padding-right: 13px;"
                       @click="onResetText(scope.$index)"></el-button>
          </el-input>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import QuestionReview from '../../question-review.js'

export default {
  mixins: [],
  props: {
    question: Object,
    texts: Array,
    disabled: Boolean,
  },
  data () {
    return {
      originalTexts: [],
      errors: [],
    }
  },
  computed: {
    ...Vuex.mapState('stepTemplate', {
      inputType: state => state.inputType,
    }),
    inputTypes () {
      let inputTypes = {}
      this.inputType.forEach(({label, value}) => {
        inputTypes[value] = label
      })
      return inputTypes
    }
  },
  watch: {},
  beforeCreate () {},
  created () {
    this.originalTexts = JSON.parse(JSON.stringify(this.texts))
    this.$nextTick(() => {})
  },
  mounted () {
  },
  methods: {
    ...Vuex.mapActions([]),
    isRight (index) {
      return this.errors[index] === false
    },
    isError (index) {
      return this.errors[index] === true
    },
    setError (index, val) {
      this.$set(this.errors, index, val)
    },
    changeText (id, val) {
      let option = QuestionReview().getOption(id)
      let index = option.index()
      // 输入的值与原始值相同，认定为未更改
      if (this.texts[index] === this.originalTexts[index]) {
        // 赋予原始值
        this.texts[index] = this.originalTexts[index]
        // 格式验证结果清除
        this.setError(index, null)
      } else {
        // 验证输入格式
        if (QuestionReview().validateMultitextValue(option.data, val)) {
          // 格式验证正确
          this.setError(index, false)
        } else {
          // 格式验证错误
          this.setError(index, true)
        }
      }
      // 修改值事件
      this.$emit('change', val)
    },
    onResetText (index) {
      // 重置原值到问题答案中
      if (this.texts[index] !== this.originalTexts[index]) {
        this.texts[index] = this.originalTexts[index]
      }
      // 重置原值到绑定变量中
      if (this.texts[index] !== this.originalTexts[index]) {
        this.$set(this.texts, index, this.originalTexts[index])
      }
      // 格式验证结果清除
      this.setError(index, null)
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/QuestionOption/MultitextOption.vue